import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { UseCaseFormData } from "../types/use-case.types"

import { useCasesQueryKeys } from "./use-cases-query-keys"
import { createUseCase } from "../api/use-cases-api"

export function useCreateUseCase() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: UseCaseFormData) => createUseCase(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: useCasesQueryKeys.list() })
    },
  })
}
